import React from 'react';
import { ReferenceLine } from 'recharts';

import dashboardStore from '../../../stores/dashboard.store';

const MAX_MARKERS = 10;

const labelStyle = { fill: 'var(--brown-grey)', fontSize: 10 };

// The Bridge charts use a categorical x-axis of bucket ISO strings, so each
// marker must snap to an existing bucket or Recharts won't render the line.
export function deployMarkerLines(buckets: {time: Date}[]) {
  if (buckets.length === 0) return [];
  const firstBucket = buckets[0].time.getTime();
  const markers = dashboardStore.markers
    .filter(marker => marker.time.getTime() >= firstBucket)
    .sort((a, b) => a.time.getTime() - b.time.getTime())
    .slice(-MAX_MARKERS);

  return markers.map(marker => {
    const bucket = buckets.filter(b => b.time.getTime() <= marker.time.getTime()).pop()!;
    return (
      <ReferenceLine key={marker.version} x={bucket.time.toISOString()}
        stroke="var(--marigold)" strokeDasharray="4 4"
        label={{ value: marker.version, position: 'insideTopRight', ...labelStyle }} />
    );
  });
}
